var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SubNavigationTabs"},[_c('v-tabs',{ref:_vm.componentRef,attrs:{"centered":_vm.centeredTabs,"mobile-breakpoint":0},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_vm._t("default",null,{"activeTab":_vm.activeTab})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }